const getters = {
    TEMPLATES: ({ templates }) => templates,
    TEMPLATE: ({ template }) => template,
    FETCH_TEMPLATES_LOADING: ({ fetchTemplatesLoading }) => fetchTemplatesLoading,
    FETCH_TEMPLATE_LOADING: ({ fetchTemplateLoading }) => fetchTemplateLoading,
    CREATE_TEMPLATE_LOADING: ({ createTemplateLoading }) => createTemplateLoading,
    UPDATE_TEMPLATE_LOADING: ({ updateTemplateLoading }) => updateTemplateLoading,
    DELETE_TEMPLATE_LOADING: ({ deleteTemplateLoading }) => deleteTemplateLoading,
}

export default getters;